@keyframes pulse {
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 color-mix(in oklch, var(--tuna-palette-secondary-light) 70%, transparent);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px color-mix(in oklch, var(--tuna-palette-secondary-light) 0%, transparent);
  }
  100% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 color-mix(in oklch, var(--tuna-palette-secondary-light) 0%, transparent);
  }
}

.blob {
  background: var(--tuna-palette-secondary-main);
  border-radius: var(--tuna-shape-radius-circle);
  margin: 8px;
  transform: scale(1);
  animation: pulse 2s infinite;
}

.placeholder {
  margin-left: 8px;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}
